import packageJson from '../../package.json';
import { envVars } from './envVars';

const getValueOrDefault = (value: string, defaultValue: string): string => {
	return new RegExp('%%%\\w+%%%').test(value) ? defaultValue : value;
};

export const ApiConfig = {
	headers: {
		accept: getValueOrDefault(
			envVars.api.headers.accept,
			'application/vnd.mbcpcjPublicConsumerLoans+json; version=3.001.000'
		),
		contentType: getValueOrDefault(envVars.api.headers['contentType'], 'application/json'),
	},
	url: getValueOrDefault(envVars.api.url, 'https://mbcplab.azure-api.net/cj/PublicConsumerLoans/'),
};

export const ContactButtonConfig = {
	url: getValueOrDefault(
		envVars.contactButton.bcp,
		'https://contacthub-experiencefe.adm-ch-mobile-fsm.in.mbcp.cloud'
	),
	urlAb: getValueOrDefault(
		envVars.contactButton.ab,
		'https://contacthub-experiencefe.adm-ch-mobile-fsm.in.mbcp.cloud'
	),
};

export const LoggerConfig = {
	debug: getValueOrDefault(envVars.logger.debug, 'true') === 'true',
	error: getValueOrDefault(envVars.logger.error, 'true') === 'true',
	log: getValueOrDefault(envVars.logger.log, 'true') === 'true',
};

export const InfoConfig = {
	buildNumber: getValueOrDefault(envVars.info.buildNumber, packageJson.version),
	publicUrl: getValueOrDefault(envVars.info.publicUrl, './'),
};
